/**
 * ── 변경사항 (ECHO 톤) ──
 * 체크박스 + 텍스트 → 칩 버튼 (SentenceTestSelection과 통일)
 */
const FlowSelection = ({ selectedTypes, setSelectedTypes }) => {
  const flowType = selectedTypes.find((item) => item.key === "flow") || {};
  const readOnly = setSelectedTypes === undefined;

  const handleLangClick = (lang) => {
    setSelectedTypes((prev) =>
      prev.map((item) =>
        item.key === "flow" ? { ...item, [lang]: !item[lang] } : item
      )
    );
  };

  const options = [
    { key: "kor", label: "한글" },
    { key: "eng", label: "영어" },
  ];

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {options.map((opt) => {
        const checked = !!flowType[opt.key];
        return (
          <button
            key={opt.key}
            onClick={() => !readOnly && handleLangClick(opt.key)}
            disabled={readOnly}
            style={{
              padding: "7px 18px",
              border: `1.5px solid ${checked ? "#00D9C0" : "#E6EDEC"}`,
              backgroundColor: checked ? "#E5FBF8" : "#FFF",
              color: checked ? "#00A396" : "#7A8490",
              borderRadius: "999px",
              fontSize: "0.82rem",
              fontWeight: 700,
              fontFamily: "inherit",
              letterSpacing: "-0.01em",
              cursor: readOnly ? "default" : "pointer",
              transition: "all .12s",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default FlowSelection;
